import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.5 20V9.733L12 3.9l7.5 5.833V20a.5.5 0 0 1-.5.5h-4V13a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v7.5H5a.5.5 0 0 1-.5-.5m6 .5h3v-7h-3zM9 22H5a2 2 0 0 1-2-2V9.489a1 1 0 0 1 .386-.79l8-6.222a1 1 0 0 1 1.228 0l8 6.222a1 1 0 0 1 .386.79v10.51a2 2 0 0 1-2 2H9",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }